module.exports = __webpack_public_path__ + "static/img/red1.225551c4.png";